import { render, staticRenderFns } from "./Blood.vue?vue&type=template&id=f8cb9ee0&"
import script from "./Blood.vue?vue&type=script&lang=js&"
export * from "./Blood.vue?vue&type=script&lang=js&"
import style0 from "./Blood.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports